import { Chip } from "@mui/material";

export const statusRender = (params) => {
  switch (params.data.acStatusName) {
    case "Neaktivan":
      return <Chip label="Neaktivan" color="error" variant="outlined" />;
    case "Aktivan":
      return <Chip label="Aktivan" color="success" variant="outlined" />;
    default:
      break;
  }
};

export const statusRenderStatus = (params) => {
  switch (params.data.status_za_aggrid) {
    case "Neaktivan":
      return <Chip label="Neaktivan" color="error" variant="outlined" />;
    case "Aktivan":
      return <Chip label="Aktivan" color="success" variant="outlined" />;
    default:
      break;
  }
};

export const statusRenderStatusNew = (params) => {
  switch (params.data.status) {
    case "0":
      return <Chip label="Neaktivan" color="error" variant="outlined" />;
    case "1":
      return <Chip label="Aktivan" color="success" variant="outlined" />;
    default:
      break;
  }
};

export const primaryRender = (params) => {
  switch (params.data.isPrimary) {
    case false:
      return <Chip label="Ne" color="error" variant="outlined" />;
    case true:
      return <Chip label="Da" color="success" variant="outlined" />;
    default:
      break;
  }
};

export const statusOrder = (params) => {
  if (!params.data || !params.data.status) return params.value;

  switch (params.data.status) {
    case "APPROVE":
      return (
        <Chip
          label="Prihvaćeno"
          color="success"
          size="small"
          variant="outlined"
        />
      );
    case "DECLINED":
      return (
        <Chip label="Odbijeno" color="error" size="small" variant="outlined" />
      );
    case "PENDING":
      return (
        <Chip
          label="Na čekanju"
          color="warning"
          size="small"
          variant="outlined"
        />
      );
    default:
      return (
        <Chip
          label="Nepoznat"
          color="default"
          size="small"
          variant="outlined"
        />
      ); // Sigurnosni fallback
  }
};
